import { Link as MuiLink } from '@mui/material';
import { useInterstateTheme } from '../../InterstateThemeProvider';
import { mergeSxStyle } from '../../common/mergeSxStyle';
import actionDefaultStyle from './actionDefaultStyle';
import { Box } from '../../Box';

/** Component that expand to reveal its content  */
import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const Action = props => {
  const {
    size = 'md',
    children,
    disabled,
    sx,
    id,
    actionIcon,
    onClick,
    ...rest
  } = props;
  const theme = useInterstateTheme();
  const boxStyle = {
    display: 'inline-flex',
    gap: '8px',
    alignItems: 'center',
    cursor: disabled ? 'not-allowed' : 'pointer',
    '& > svg': {
      paddingBottom: size === 'xs' ? '0.5px' : ''
    }
  };
  const style = mergeSxStyle(actionDefaultStyle(theme, size, disabled), sx);
  const renderIcon = (condition, icon) => {
    if (condition) {
      return /*#__PURE__*/_jsx(_Fragment, {
        children: icon
      });
    }
    null;
  };
  return /*#__PURE__*/_jsx(MuiLink, {
    id: id,
    "aria-disabled": disabled,
    disabled: disabled,
    "data-testid": rest['data-testid'],
    sx: style,
    underline: "none",
    component: 'button',
    onClick: onClick,
    ...rest,
    children: /*#__PURE__*/_jsxs(Box, {
      component: "span",
      className: "ids-action",
      sx: boxStyle,
      children: [renderIcon(actionIcon?.start, actionIcon?.icon), children, renderIcon(actionIcon?.end, actionIcon?.icon)]
    })
  });
};
Action.displayName = 'Action';